import { Col, Form } from 'antd';
import CustomInputLabel from 'components/Label/CustomInputLabel';

const checkColorByStatus = {
	Active: '#00b050',
	'W-I-P': '#ff3300',
	Inactive: '#BB2222',
	draft: '#BB2222',
	Onboarded: '#00b050',
};

const ModalActivationStatusInput = ({ label = 'Status', name = 'activationStatus', activationStatus, xs = 24, md = 8, lg = 6, style }) => {
	return (
		<>
			{/* <Col xs={xs} md={md} lg={lg}>
				<CustomInputLabel label={label} head={true} sx={{ ...style }} />
			</Col> */}

			{/* <Col flex="auto">
				<Form.Item name={name} style={style}>
					<CustomInputLabel
						label={activationStatus}
						sx={{
							borderColor: '#d9d9d9',
							textTransform: 'Capitalize',
							color: checkColorByStatus?.[activationStatus] ?? '#BB2222',

							...style,
						}}
					/>
				</Form.Item>
			</Col> */}
		</>
	);
};

export default ModalActivationStatusInput;
